import { render } from "./BugReportWidget.vue?vue&type=template&id=46e5c42b&scoped=true&ts=true"
import script from "./BugReportWidget.vue?vue&type=script&lang=ts"
export * from "./BugReportWidget.vue?vue&type=script&lang=ts"

import "./BugReportWidget.vue?vue&type=style&index=0&id=46e5c42b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e5c42b"]])

export default __exports__